// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors","commons","hc/css/appv2"], () => (__webpack_require__("./resources/assets/js/hcv2/apps/app.campaign.luckybox.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","commons","hc/css/appv2"], () => (__webpack_require__("./resources/assets/css/hcv2/app.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
